import React from 'react'
import { Modal, Frame } from '@react95/core'
import { Heading } from '@pancakeswap/uikit'
import { Progman21 } from '@react95/icons'
import { useTranslation } from 'contexts/Localization'

const XXXModal = ({ close, modalStyle, frameStyle }) => {
  const { t } = useTranslation()

  return (
    <Modal
      defaultPosition={{ x: 12, y: 12 }}
      icon={<Progman21 />}
      title="How to Buy"
      closeModal={close}
      width="90vw"
      height="90vh"
      style={modalStyle}
      buttons={[{ value: 'Ok', onClick: close }]}
    >
      <Frame style={frameStyle}>
        <Heading scale="xl" mb="16px" mt="16px">
          {t(`BUSTED!`)}
        </Heading>

        <img
          width="500"
          height="934"
          src="https://uploads-ssl.webflow.com/619551a9ec00d55c6c61ff0d/61dfcafbb7f0ba84ce784d60_jVfI5wQ.png"
          alt=""
          loading="lazy"
        />
      </Frame>
    </Modal>
  )
}

export default XXXModal
